import React, { useState } from "react";
import { TextField, Autocomplete, Typography, Stack } from "@mui/material";

import InfoMsg from "./InfoMsg";

type Option = {
  value: number | string;
  label: string;
};

type Props = {
  value: number | string | undefined | null;
  disableClearable?: boolean;
  options: Option[];
  placeholder: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  info?: string;
  onChange?: (val: number | string) => void;
};

const ComboBox = ({
  options,
  value,
  onChange,
  placeholder,
  label,
  info,
  required = false,
  disabled = false,
  disableClearable = true,
}: Props) => {
  const [touched, setTouched] = useState(false);
  const isError = required && touched && (value === null || value === undefined || value === "");
  const getValue = (value: number | string | undefined | null) => {
    if (value === undefined || value === null) {
      return null;
    }
    const opt = options.find((rec) => rec.value === value);
    if (opt) {
      return opt;
    }
    return null;
  };
  const handleIsOptionEqualToValue = (option: Option, val: Option) => {
    return option.value === val.value;
  };
  return (
    <Autocomplete
      // disablePortal
      disableClearable={disableClearable}
      size="small"
      disabled={disabled}
      isOptionEqualToValue={handleIsOptionEqualToValue}
      value={getValue(value)}
      options={options}
      onChange={(e, option) => {
        if (option && onChange) {
          onChange(option.value);
        }
      }}
      onBlur={() => setTouched(true)}
      renderInput={(params) => (
        <>
          {label && (
            <Stack direction="row">
              <Typography
                component="span"
                variant="subtitle2"
                className={`${required ? "field-required" : ""}`}
              >
                {label}
              </Typography>
              {info && <InfoMsg info={info} />}
            </Stack>
          )}
          <TextField
            {...params}
            placeholder={placeholder}
            error={isError}
            helperText={
              isError ? "Field is required" : ""
            }
          />
        </>
      )}
    />
  );
};

export default ComboBox;
